import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/index'
import './plugins/axios'
// import './plugins/jspdf'
import './plugins/components'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created () {
    this.$store.dispatch('ME')
    this.$store.dispatch('STORE')
  }
}).$mount('#app')
